<template>
  <div class="bdg-files-list flex flex-col justify-between w-full">
    <h3 class="text-sm font-light pb-1" v-if="!noSectionName">
      {{ sectionName || "Files:" }}
    </h3>

    <div :class="{ striped }">
      <bdg-file-cell
        :file="item"
        v-for="(item, index) in items"
        :key="`${item.filename}-${index}`"
        :md-uses-buttons="mdUsesButtons"
        :hide-delete-button="hideDeleteButton"
        @view="$emit('view', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>
  </div>
</template>

<script>
import BdgFileCell from "./BdgFileCell";

export default {
  name: "BdgFilesList",
  components: { BdgFileCell },
  props: {
    items: [Array, FileList],
    sectionName: String,
    striped: Boolean,
    noSectionName: Boolean,
    mdUsesButtons: Boolean,
    hideDeleteButton: Boolean
  }
};
</script>
